import { buildAuthProvider } from 'react-admin-amplify';

const baseAuthProvider = buildAuthProvider();

const authProvider = {
  ...baseAuthProvider,
  checkAuth: async () => {
    const publicRoutes = ['/forgot-password'];
    if (publicRoutes.includes(window.location.pathname)) {
      return Promise.resolve();
    }
    return baseAuthProvider.checkAuth();
  }
}

export default authProvider;
export { authProvider };
